import React from 'react';

import { useI18n } from 'common/hooks';

import { ServerError } from 'components/ServerError';

const TemporarilyUnavailableError: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { translateToText } = useI18n();
  return (
    <div className={className}>
      <ServerError
        className='text-center'
        error={translateToText('mobile:derivatives:order-details:featureunavailable')}
      />
    </div>
  );
};

export default TemporarilyUnavailableError;
